(() => {
  // app/scripts/predictive-search.js
  var PredictiveSearch = class extends HTMLElement {
    connectedCallback() {
      const { serializeForm, debounceTime } = theme;
      this.form = this.querySelector("form");
      this.input = this.querySelector("[name=q]");
      this.serializeForm = serializeForm;
      this.addEventListener(
        "input",
        debounceTime((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
      this.input.addEventListener("click", this.onFocus.bind(this));
      this.input.addEventListener("touchstart", this.onFocus.bind(this), { passive: true });
      this.addEventListener("focusout", this.onFocusOut.bind(this));
      this.addEventListener("keyup", this.onKeyup.bind(this));
    }
    onChange(e) {
      console.log("testing right now");
      const key = e.target.value.trim();
      if (!key.length) {
        this.close();
        return;
      }
      this.getRequest(key);
    }
    getRequest(key, recommend) {
      this.searchQuery = JSON.parse(this.serializeForm(this.form));
      this.searchQuery.q = key;
      this.searchQuery.section_id = this.dataset.section;
      this.classList.add("is-searching");
      const query = new URLSearchParams(this.searchQuery).toString();
      const url = this.dataset.url + "?" + query;
      fetch(url).then((e) => e.text()).then((html) => {
        this.querySelector(".js-search-result").innerHTML = html.split("<!-- /// -->")[1];
      }).finally(() => {
        this.classList.remove("is-searching");
        this.open();
      });
    }
    // focusSearch() {
    //     console.log("focusSearch");
    //     this.input.focus();
    // }
    open() {
      this.classList.add("show");
    }
    close() {
      this.classList.remove("show");
    }
    onFocus() {
      this.open();
    }
    onFocusOut() {
      setTimeout(() => {
        if (!this.contains(document.activeElement))
          this.close();
      });
    }
    onKeyup(event) {
      if (event.code == "Escape")
        this.close();
    }
  };
  customElements.define("predictive-search", PredictiveSearch);
})();
